// extracted by mini-css-extract-plugin
export var button = "_d1-4";
export var hasDarkBackground = "_d1-7";
export var hasLightBackground = "_d1-6";
export var iconWrapper = "_d1-0";
export var large = "_d1-2";
export var medium = "_d1-1";
export var small = "_d1-5";
export var xsmall = "_d1-3";